import { getWPData, mapWPDataToArticle, REBUILD_TIMEOUT } from "../../../lib";
import Articles from "..";
import { WPCategory } from "./[slug]";
import { Wordpress } from "@ecologi/shared";
import logger from "../../../lib/logger";

// Use the same component as the base articles index view
export default Articles;

export async function getStaticProps({ params }) {
  const allCategories: WPCategory[] = await getWPData(
    `categories?per_page=${Wordpress.WORDPRESS_FETCH_PER_PAGE}`
  );

  const category = allCategories.find((cat) => cat.slug === params.category);

  let data = [];
  let pageNumber = 1;

  while (true) {
    const res = await getWPData(
      `posts?filter[cat]=${category.id}&per_page=${Wordpress.WORDPRESS_FETCH_PER_PAGE}&page=${pageNumber}&_embed`
    );

    if (!Array.isArray(res)) break;

    data = [...res, ...data];
    pageNumber++;

    logger.info(`Waiting on page ${pageNumber} for 'articles/[category]'...`);
    await new Promise((res) => setTimeout(res, 2e3)); // don't DOS the site
  }

  data.sort((a, b) => (a.date_gmt > b.date_gmt ? -1 : 1));

  return {
    revalidate: REBUILD_TIMEOUT,
    props: {
      data: data.map(mapWPDataToArticle),
      categoryName: category.name,
      layoutProps: {
        isLightHeader: true,
        isWhiteBody: true,
      },
    },
  };
}

export async function getStaticPaths() {
  const allCategories: WPCategory[] = await getWPData(
    `categories?per_page=${Wordpress.WORDPRESS_FETCH_PER_PAGE}&_fields=slug`
  );

  return {
    paths: allCategories.map((category) => `/articles/${category.slug}`) || [],
    fallback: false,
  };
}
